function getTag(object: any) {
	return Object.prototype.toString.call(object);
}

/**
 * Not a complete isEqual implementation, just fulfills our needs
 */
export function isEqual(object: any, other: any) {
	if (!object || !other) {
		return object === other;
	}

	if (typeof object === "object" && typeof other === "object") {
		let tagObject = getTag(object);
		let tagOther = getTag(other);

		if (tagObject === tagOther) {
			if (tagObject === "[object Date]") {
				return object.getTime() === other.getTime();
			} else if (tagObject === "[object Array]") {
				if (object.length !== other.length) {
					return false;
				}

				for (let i = 0; i < object.length; i++) {
					if (!isEqual(object[i], other[i])) {
						return false;
					}
				}

				return true;
			}

			for (let [key, value] of Object.entries(object)) {
				if (!isEqual(other[key], value)) {
					return false;
				}
			}

			return true;
		}

		return false;
	}

	return object === other;
}
